import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { createStyles, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const styles = makeStyles((theme) =>
    createStyles({
        o: {},
        "@global": {
            ".css-1kpdewa-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input":
                {
                    padding: "0px 4px 0px 6px !important",
                    fontSize: 14,
                    fontFamily: "Josefin Sans"
                },
            ".css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root":{
                fontFamily: "Josefin Sans!important"
            }
        },
    })
);

export default function AutoCompleteSolo(props: {
    id?: string;
    name: string;
    values: any;
    selectedValues: any | null;
    onChangeSelect: (v: any) => void;
    isUpdating?: boolean;
    isNotOutlined?: boolean;
    getOptionLabel?: (option: any) => string; // Add this line
    getOptionSelected?: (option: any, value: any) => boolean;
    disabled?: boolean; // Add this line if needed
}) {
    const { t } = useTranslation<'common'>();
    let isReadOnlyDefaultValue: boolean = props.isUpdating || false;
    const handleChangeOption = (event: any, newValue: any) => {
        props.onChangeSelect(newValue);
    };
    const classes = styles();
    return (
        <Stack spacing={3}>
            <Autocomplete
                id={props.id ? props.id : "idAutoCompleteWithChips"}
                options={props.values}
                /*getOptionLabel={(option) =>
                    option.name
                        ? option.label
                            ? t(option.label)
                            : option.name
                        : ""
                }*/
                onChange={handleChangeOption}
                value={props.selectedValues}
                className={classes.o}
                disabled={isReadOnlyDefaultValue}
                renderInput={(params) => <TextField {...params} />}
                isOptionEqualToValue={props.getOptionSelected || ((option, value) => option === value)}
                getOptionLabel={props.getOptionLabel ? 
                    (option) => props.getOptionLabel!(option) : 
                    (option) => option.name || ""
                }
            />
        </Stack>
    );
}
